export type Testimonial = {
  quote: string;
  name: string;
  location: string;
  flag: string;
  img: string;
};

export const testimonials: Testimonial[] = [
  {
    quote:
      "J'avais mes séances de natation dans une application, mes entraînements de vélo dans un tableur et mes plans de course à pied dans mes notes. Les six phases m'ont enfin permis de tout organiser au même endroit. Pour la première fois, je comprends le rôle de chaque semaine.",
    name: 'Romain M.',
    location: 'Annecy · France',
    flag: '🇫🇷',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/245e3c6e-1832-4640-9b91-d62e5f50478e.jpg',
  },
  {
    quote:
      "La natation était toujours la séance que je finissais par sauter. Voir la natation, le vélo et la course à pied organisés ensemble m'a aidée à arrêter de les traiter comme trois activités séparées. Mes semaines me semblent enfin plus équilibrées.",
    name: 'Julie K.',
    location: 'Lausanne · Suisse',
    flag: '🇨🇭',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/871b0c24-f3dc-4097-8ee8-ba51403f62ee.jpg',
  },
  {
    quote:
      "À 45 ans, avec un emploi à temps plein, je ne peux pas me permettre de perdre du temps à organiser mes séances. Le calendrier de 40 semaines me permet de visualiser où j'en suis et ce qui vient ensuite.",
    name: 'Thierry H.',
    location: 'Lille · France',
    flag: '🇫🇷',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/cc5fe406-07dc-46de-9ed4-a909d8a4afc1.jpg',
  },
];

export const moreTestimonials: Testimonial[] = [
  {
    quote:
      "Le guide du ravitaillement était la pièce qui me manquait. Avant, je manquais d'énergie à chaque longue sortie vélo. Maintenant, je prépare mon ravitaillement avant la séance, et non au milieu.",
    name: 'Marie D.',
    location: 'Montréal · Canada',
    flag: '🇨🇦',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/f73ff9f9-51ec-49bc-a116-ca754d165244.jpg',
  },
  {
    quote:
      "Le carnet de suivi m'aide à rester honnête avec moi-même. Voir ma régularité semaine après semaine dans les trois disciplines m'en apprend plus que n'importe quelle grosse séance.",
    name: 'Nicolas W.',
    location: 'Bruxelles · Belgique',
    flag: '🇧🇪',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/3e920b48-8782-464e-913d-6b0370c1c02a.jpg',
  },
  {
    quote:
      "La semaine de course, c'était toujours le chaos. La checklist l'a transformée en plan : sacs prêts, transitions organisées, matin de course anticipé. Pour la première fois, je suis arrivée sereine au départ.",
    name: 'Émilie S.',
    location: 'Nice · France',
    flag: '🇫🇷',
    img: 'https://cdn.magicpatterns.com/patterns/generated-images/8c58620e-0a73-47c2-b355-837eca5ebe81.jpg',
  },
];
